export const environment = {
  production: true,
  url: 'https://api-brandmr-dev.procit.com/',
};
